import { h1, h2, h3, p, a, ul, li } from 'data/helpers/prose'
import { useMobileApp } from 'data/hooks/MobileApp/useMobileApp'
import { Maybe, Media } from 'gql/graphql'
import classNames from 'classnames'
import InformationSection from 'components/sections/InformationSection'

interface GetToKnowSectionProps {
  getToKnow?: {
    description?: string | null,
    media?: Maybe<Pick<Media, 'url' | 'file_name'>>
  }
  destination?: string
  parentDescription?: string
}

const GetToKnowSection = ({
  getToKnow,
  destination,
  parentDescription,
}: GetToKnowSectionProps) => {
  const { isMobileApp }  = useMobileApp()

  if (isMobileApp || !destination) { return null }

  return (
    <InformationSection
      subtitle={`Get to know ${destination}`}
      className={{
        container: 'mt-50 md:mt-50',
        content: {
          text: classNames(h1, h2, h3, a, p, ul, li, 'text-grey-750 my-auto whitespace-pre-wrap'),
        },
      }}
      text={(parentDescription || getToKnow?.description)
        ? <div dangerouslySetInnerHTML={{ __html: (parentDescription ?? getToKnow?.description)! }} />
        : undefined
      }
      image={getToKnow?.media?.url
        ? {
          url: getToKnow.media.url,
          altText: getToKnow.media.file_name,
        }
        : undefined
      }
      variant="full-width"
    />
  )
}

export default GetToKnowSection
